<template>
  <div class="workforce-tab">
    <v-data-table
      :headers="headers"
      :items="manpowers"
      hide-default-footer
      fixed-header
      height="500"
      :items-per-page="-1"
      class="mb-6"
    >
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Main d'oeuvre</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template #activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Nouveau</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="lastname"
                        :error="errors.has('lastname')"
                        v-model="editedItem.name"
                        label="Nom"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-validate="'required'"
                        data-vv-name="firstname"
                        :error="errors.has('firstname')"
                        v-model.number="editedItem.firstname"
                        label="Prénom"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model.number="editedItem.hourly_cost"
                        label="Coût Horaire"
                        type="number"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="save"
                  >Enregistrer</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Hourly cost -->
      <template #item.hourly_cost="{ value }">
        {{ value | currency }}
      </template>

      <!-- Actions -->
      <template #item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import ManpowerRepo from "@/repositories/settings/manpower";

  export default {
    name: "ManpowerTab",
    data() {
      return {
        headers: [
          {
            text: "Nom",
            align: "left",
            value: "name"
          },

          {
            text: "Prénom",
            align: "left",
            value: "firstname"
          },

          {
            text: "Coût horaire",
            align: "left",
            value: "hourly_cost"
          },

          {
            text: "Actions",
            value: "action",
            sortable: false
          }
        ],

        manpowers: [],

        defaultItem: {
          name: "",
          firstname: "",
          hourly_cost: null
        },

        dialog: false,
        editedId: -1,
        editedItem: {
          name: "",
          firstname: "",
          hourly_cost: null
        }
      };
    },
    computed: {
      formTitle() {
        return this.editedId === -1
          ? "Ajouter une main d'oeuvre"
          : "Modifier une main d'oeuvre";
      }
    },
    methods: {
      editItem(item) {
        this.editedId = item.id;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      /**
       * Delete a manpower
       */
      async deleteItem(item) {
        confirm("Are you sure you want to delete this item?") &&
          (await ManpowerRepo.deleteManpower(item.id));

        this.getManpowers();
      },

      /**
       * Save manpower on server
       */
      async save() {
        // Check if form is valid
        const isValid = await this.$validator.validateAll();

        if (!isValid) {
          return;
        }

        if (this.editedId > -1) {
          await ManpowerRepo.updateManpower(this.editedId, this.editedItem);
        } else {
          await ManpowerRepo.create(this.editedItem);
        }

        this.getManpowers();
        this.close();
      },

      /**
       * Close dialog and reset edited item
       */
      close() {
        this.dialog = false;
        this.errors.clear();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedId = -1;
        }, 300);
      },

      /**
       * Get all manpowers
       */
      async getManpowers() {
        try {
          const { data } = await ManpowerRepo.get();
          this.manpowers = data;
        } catch (error) {
          alert(error);
        }
      }
    },
    created() {
      this.getManpowers();
    }
  };
</script>

<style lang="scss">
  .supports-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
    .v-data-table table tr td {
      height: auto !important;
    }
    .v-data-table table tbody td .v-input .v-input__control .v-input__slot {
      height: auto !important;
    }
  }
</style>
